// `Skeleton` — the loading-placeholder primitive: a full-width glimmer
// rectangle that pulses while real content is on its way. Purely decorative,
// so the root is always hidden from assistive tech. Size is the consumer's
// concern (height/width via a BEM class in the consumer's own sheet); the
// atom owns the glimmer, the surface tint, and the radius (`shape='circle'`
// for avatar placeholders).

import type { HTMLAttributes } from 'react';
import { useId } from 'react';

import { classlist } from '~/_shared/design-system/lib/classlist';

import './skeleton.css';

type SkeletonShape = 'rect' | 'circle';

interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
	shape?: SkeletonShape;
}

const Skeleton = ({
	shape = 'rect',
	id,
	className,
	...rest
}: SkeletonProps) => {
	const generated_id = useId();
	return (
		<span
			{...rest}
			id={id ?? `Skeleton-${generated_id}`}
			aria-hidden='true'
			className={classlist(
				'skeleton',
				shape === 'circle' && 'skeleton--circle',
				className,
			)}
		/>
	);
};

export type { SkeletonProps, SkeletonShape };
export { Skeleton };
